var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EventEmitter, OnInit, AfterViewInit } from '@angular/core';
import { DomManipulationService } from '../../services/dom-manipulation/dom-manipulation.service';
import { RECAPTCHA_SCRIPT } from '../../classes/dynamicScripts';
import { APP_RECAPTCHA_KEY } from '../../app-config.constants';
import { HasSubscriptions } from '../has-subscriptions';
var RecaptchaComponent = /** @class */ (function (_super) {
    __extends(RecaptchaComponent, _super);
    function RecaptchaComponent(domManipulationService) {
        var _this = _super.call(this) || this;
        _this.domManipulationService = domManipulationService;
        _this.recaptchaIdCreated = new EventEmitter();
        _this.uniqueId = 'app-recaptcha-' + RecaptchaComponent.nextId;
        RecaptchaComponent.nextId++;
        return _this;
    }
    RecaptchaComponent.prototype.ngOnInit = function () {
        this.domManipulationService.loadScript(RECAPTCHA_SCRIPT);
    };
    RecaptchaComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.addSub(this.domManipulationService.loadScript(RECAPTCHA_SCRIPT).subscribe(function () {
            _this._widgetId = grecaptcha.render(_this.uniqueId, {
                badge: 'inline',
                sitekey: APP_RECAPTCHA_KEY,
                size: 'invisible',
                callback: _this.resetAfterCallback.bind(_this)
            });
            _this.recaptchaIdCreated.emit(_this._widgetId);
        }));
    };
    RecaptchaComponent.prototype.resetAfterCallback = function (recaptchaToken) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (!recaptchaToken) {
                reject();
            }
            _this.onSubmit(recaptchaToken);
            grecaptcha.reset(_this._widgetId);
            resolve();
        });
    };
    RecaptchaComponent.nextId = 0;
    return RecaptchaComponent;
}(HasSubscriptions));
export { RecaptchaComponent };
